var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIssuesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_1800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 17.6925V14.9925C4.4925 14.7975 1.5 11.6775 1.5 7.875C1.5 3.945 4.695 0.75 8.625 0.75C12.555 0.75 15.75 3.945 15.75 7.875C15.75 11.5875 13.17 15.3225 9.3225 17.175L8.25 17.6925ZM8.625 2.25C5.52 2.25 3 4.77 3 7.875C3 10.98 5.52 13.5 8.625 13.5H9.75V15.225C12.48 13.5 14.25 10.665 14.25 7.875C14.25 4.77 11.73 2.25 8.625 2.25ZM7.875 10.875H9.375V12.375H7.875V10.875ZM9.375 9.75H7.875C7.875 7.3125 10.125 7.5 10.125 6C10.125 5.175 9.45 4.5 8.625 4.5C7.8 4.5 7.125 5.175 7.125 6H5.625C5.625 4.3425 6.9675 3 8.625 3C10.2825 3 11.625 4.3425 11.625 6C11.625 7.875 9.375 8.0625 9.375 9.75Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_1800"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssuesIcon);
export default __webpack_public_path__ + "static/media/issues-icon.ca3b0c9858cc2008fc4d6ca0003c69e4.svg";
export { ForwardRef as ReactComponent };